import classnames from 'classnames/bind'

import ProductCard, { ProductCardProps } from '~/components/Slices/ProductCard'
import SearchLineItem from '~/components/Slices/Search/SearchLineItem'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = [{ ratio: 1 / 6 }]

function ResultItem({ className, index, ...rest }: ProductCardProps) {
  return (
    <div className={cx(className, css.ResultItem)}>
      <SearchLineItem
        className={cx(css.hideOnLargeScreen)}
        {...rest}
        index={index}
      />
      <ProductCard
        className={cx(css.hideOnSmallScreen)}
        sizesFromBreakpoints={IMAGE_SIZES}
        {...rest}
      />
    </div>
  )
}

ResultItem.defaultProps = {}

export default ResultItem
